/**
 * render-live-streaming-csv
 *
 * @author    Alexis Vedia <alexis.vedia@mediatel.co.uk>
 * @copyright 2017 Mediatel Limited.
 */

"use strict";

export default function renderWeeklyReportCSV(data, options) {
    const rows = data.map((stationData, i) => {
        return `"${stationData.name}",` +
            `"${(stationData.total_playtime && stationData.total_playtime != 0) ? stationData.total_playtime : '-'}",` +
            `"${(stationData.own_apps && stationData.own_apps != 0) ? stationData.own_apps : '-'}",` +
            `"${(stationData.other_apps && stationData.other_apps != 0) ? stationData.other_apps : '-'}",` +
            `"${(stationData.bbc_playtime && stationData.bbc_playtime != 0) ? stationData.bbc_playtime : '-'}",` +
            `"${(stationData.sky_playtime && stationData.sky_playtime != 0) ? stationData.sky_playtime : '-'}",` +
            `"${(stationData.my5_playtime && stationData.my5_playtime != 0) ? stationData.my5_playtime : '-'}",` +
            `"${(stationData.itvstv_playtime && stationData.itvstv_playtime != 0) ? stationData.itvstv_playtime : '-'}"`;
    }).join("\n");

    return `"${options.labelTableName}",` +
        `"Total minutes",` +
        `"Own apps",` +
        `"Other platforms",` +
        `"BBC iPlayer",` +
        `"Sky Go",` +
        `"My5",` +
        `"ITV/STV player"` +
        `\r\n${rows}`;
}
